const resultDialog = {
  importResult: "导入结果",
  failReason: "失败原因",
  noFailReason: "无导入失败信息",
  importSuccess: "导入成功",
  unit: "条",
  importFail: "导入失败"
} 
export default resultDialog